import React from "react";

const Copy = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="35"
      viewBox="0 0 28 35"
    >
      <script xmlns="" />
      <script xmlns="" />
      <defs>
        <clipPath id="clip-path">
          <rect
            id="사각형_1722"
            data-name="사각형 1722"
            width="28"
            height="35"
            fill="none"
            stroke="#707070"
            strokeWidth="1.4"
          />
        </clipPath>
      </defs>
      <g id="그룹_1006" data-name="그룹 1006" transform="translate(0 0)">
        <g id="그룹_1005" data-name="그룹 1005" clipPath="url(#clip-path)">
          <path
            id="패스_3539"
            data-name="패스 3539"
            d="M20.079,10.438V29.691H.5V2.97H12.918Z"
            transform="translate(0.689 4.116)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="1.4"
          />
          <path
            id="패스_3540"
            data-name="패스 3540"
            d="M16.576,27.221h6.042V.5H3.04V6.393"
            transform="translate(4.192 0.693)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="1.4"
          />
        </g>
      </g>
      <path
        id="패스_3541"
        data-name="패스 3541"
        d="M13.11,10.639H5.721V2.97"
        transform="translate(7.742 4.062)"
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="1.4"
      />
    </svg>
  );
};

export default Copy;
